import React from "react";
import {
  FaHome,
  FaRegBookmark,
  FaRegClock,
  FaChromecast,
  FaUser,
} from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";
import { RiCommunityLine } from "react-icons/ri";
import { BiHelpCircle, BiLogOut } from "react-icons/bi";
import {
  MdOutlineKeyboardDoubleArrowRight,
  MdOutlineVideoLibrary,
} from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { PiFilmReelFill } from "react-icons/pi";
import { NavLink } from "react-router-dom";

const MainSidebar = ({ toggleCollpased, path, isCollapsed }) => {
  return (
    <>
      <div
        className="sidebar_section position-relative"
        style={{ overflowX: "hidden", height: "calc(100vh - 56px)" }}
      >
        {!isCollapsed ? (
          <div className="d-flex justify-content-between flex-column text-white p-4">
            <div className="h-100 lh-1">
              <div className="menu-section">
                <h6 className="section-title">Menu</h6>
                <ul className="menu-list">
                  <NavLink to={"/home"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/home" && "active"
                      }`}
                    >
                      <FaHome className="menu-icon" />
                      <span>Home</span>
                    </li>
                  </NavLink>
                  <NavLink to={"/shortVideo"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/shortVideo" && "active"
                      }`}
                    >
                      <PiFilmReelFill className="menu-icon" />
                      <span>Trailer</span>
                    </li>
                  </NavLink>
                  <li className="menu-item text-white">
                    <RiCommunityLine className="menu-icon" />
                    <span>Community</span>
                  </li>
                  <li className="menu-item text-white">
                    <MdOutlineVideoLibrary className="menu-icon" />
                    <span>Coming Soon</span>
                    <span className="sidebarbadge">3</span>
                  </li>
                </ul>
              </div>
              <div className="library-section">
                <h6 className="section-title">LIBRARY</h6>
                <ul className="menu-list">
                  <NavLink to={"/watchHistory"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/watchHistory" && "active"
                      }`}
                    >
                      <FaRegClock className="menu-icon" />
                      <span>Watch History</span>
                    </li>
                  </NavLink>
                  <NavLink to={"/myList"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/myList" && "active"
                      }`}
                    >
                      <FaRegBookmark className="menu-icon" />
                      <span>MY List</span>
                    </li>
                  </NavLink>
                  <NavLink to={"/activateTV"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/activateTV" && "active"
                      }`}
                    >
                      <FaChromecast className="menu-icon" />
                      <span>Activate TV</span>
                    </li>
                  </NavLink>
                  <li className="menu-item text-white">
                    <AiOutlineDownload className="menu-icon" />
                    <span>Downloaded</span>
                  </li>
                </ul>
              </div>
              <div className="settings-section">
                <ul className="menu-list">
                  <NavLink to={"/myAccount"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/myAccount" && "active"
                      }`}
                    >
                      <FaUser className="menu-icon" />
                      <span>My Account</span>
                    </li>
                  </NavLink>
                  <NavLink to={"/help"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/help" && "active"
                      }`}
                    >
                      <BiHelpCircle className="menu-icon" />
                      <span>Help Center</span>
                    </li>
                  </NavLink>
                </ul>
              </div>
              <div className="logout-section">
                <ul className="menu-list">
                  <li className="menu-item text-white">
                    <BiLogOut className="menu-icon" />
                    <span>Logout</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="menu-item text-white" onClick={toggleCollpased}>
              <div>
                {isCollapsed ? (
                  <MdOutlineKeyboardDoubleArrowRight className="menu-icon" />
                ) : (
                  <MdOutlineKeyboardDoubleArrowLeft className="menu-icon" />
                )}
                <span>Collapse Menu</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-between flex-column text-white p-4">
            <div className="h-100">
              <div className="menu-section">
                <h6 className="section-title">Menu</h6>
                <ul className="menu-list">
                  <NavLink to={"/home"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/home" && "active"
                      }`}
                    >
                      <FaHome className="menu-icon" />
                    </li>
                  </NavLink>
                  <NavLink to={"/shortVideo"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/shortVideo" && "active"
                      }`}
                    >
                      <PiFilmReelFill className="menu-icon" />
                    </li>
                  </NavLink>
                  <li className="menu-item text-white">
                    <RiCommunityLine className="menu-icon" />
                  </li>
                  <li className="menu-item text-white">
                    <MdOutlineVideoLibrary className="menu-icon" />
                    <span className="sidebarbadge">3</span>
                  </li>
                </ul>
              </div>
              <div className="library-section">
                <h6 className="section-title">LIBRARY</h6>
                <ul className="menu-list">
                  <NavLink to={"/watchHistory"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/watchHistory" && "active"
                      }`}
                    >
                      <FaRegClock className="menu-icon" />
                    </li>
                  </NavLink>
                  <NavLink to={"/myList"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/myList" && "active"
                      }`}
                    >
                      <FaRegBookmark className="menu-icon" />
                    </li>
                  </NavLink>
                  <NavLink to={"/activateTV"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/activateTV" && "active"
                      }`}
                    >
                      <FaChromecast className="menu-icon" />
                    </li>
                  </NavLink>
                  <li className="menu-item text-white">
                    <AiOutlineDownload className="menu-icon" />
                  </li>
                </ul>
              </div>
              <div className="settings-section">
                <ul className="menu-list">
                  <NavLink to={"/myAccount"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/myAccount" && "active"
                      }`}
                    >
                      <FaUser className="menu-icon" />
                    </li>
                  </NavLink>
                  <NavLink to={"/help"}>
                    <li
                      className={`menu-item text-white ${
                        path === "/help" && "active"
                      }`}
                    >
                      <BiHelpCircle className="menu-icon" />
                    </li>
                  </NavLink>
                </ul>
              </div>
              <div className="logout-section">
                <ul className="menu-list">
                  <li className="menu-item text-white">
                    <BiLogOut className="menu-icon" />
                  </li>
                </ul>
              </div>
            </div>
            <div className="menu-item text-white" onClick={toggleCollpased}>
              <div>
                {isCollapsed ? (
                  <MdOutlineKeyboardDoubleArrowRight className="menu-icon" />
                ) : (
                  <MdOutlineKeyboardDoubleArrowLeft className="menu-icon" />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MainSidebar;
